<template>
    <div class="confirmation-backdrop" @click.self="$emit('cancel')">
        <div class="card">
            <div class="header">
                <div class="image">
                    <svg
                        aria-hidden="true"
                        stroke="currentColor"
                        stroke-width="1.5"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
                    </svg>
                </div>
                <div class="content">
                    <span class="title">Confirmation</span>
                    <p class="message">Are you sure you want to change the option?</p>
                </div>
                <div class="actions">
                    <button 
                        class="confirm" 
                        type="button"
                        @click="$emit('confirm')"
                    >
                        Yes
                    </button>
                    <button 
                        class="cancel" 
                        type="button"
                        @click="$emit('cancel')"
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConfirmationDialog',
}
</script>

<style scoped>
.confirmation-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.card {
    width: 90%;
    max-width: 400px;
    margin: 1rem;
    overflow: hidden;
    position: relative;
    background-color: #ffffff;
    text-align: left;
    border-radius: 0.5rem;
    box-shadow:
        0 20px 25px -5px rgba(0, 0, 0, 0.1),
        0 10px 10px -5px rgba(0, 0, 0, 0.04);
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.header {
    padding: 1.25rem 1rem 1rem 1rem;
    background-color: #ffffff;
}

.image {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    background-color: var(--secondary-color, #FEE9E9);
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    border-radius: 9999px;
}

.image svg {
    color: var(--primary-color, #2563eb);
    width: 1.5rem;
    height: 1.5rem;
}

.content {
    margin-top: 0.75rem;
    text-align: center;
}

.title {
    color: #111827;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
}

.message {
    margin-top: 0.5rem;
    color: #6b7280;
    font-size: 0.875rem;
    line-height: 1.25rem;
}

.actions {
    margin: 0.75rem 1rem;
    background-color: #f9fafb;
}

.confirm {
    display: inline-flex;
    padding: 0.5rem 1rem;
    background-color: var(--primary-color, #2563eb);
    color: #ffffff;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;
    justify-content: center;
    width: 100%;
    border-radius: 0.375rem;
    border-width: 1px;
    border-color: transparent;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.cancel {
    display: inline-flex;
    margin-top: 0.75rem;
    padding: 0.5rem 1rem;
    background-color: #ffffff;
    color: #374151;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;
    justify-content: center;
    width: 100%;
    border-radius: 0.375rem;
    border: 1px solid #d1d5db;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

button {
    cursor: pointer;
}

.confirm:hover {
    background-color: #1d4ed8;
}

.cancel:hover {
    background-color: #f3f4f6;
}
</style>